export const outcodes = [
  "DE1",
  "DE3",
  "DE4",
  "DE5",
  "DE6",
  "DE7",
  "DE11",
  "DE12",
  "DE13",
  "DE14",
  "DE15",
  "DE21",
  "DE22",
  "DE23",
  "DE24",
  "DE45",
  "DE56",
  "DE65",
  "DE72",
  "DE73",
  "DE74",
  "DE75",
  "DN1",
  "DN2",
  "DN3",
  "DN4",
  "DN5",
  "DN6",
  "DN7",
  "DN8",
  "DN9",
  "DN10",
  "DN11",
  "DN12",
  "DN14",
  "DN15",
  "DN16",
  "DN17",
  "DN18",
  "DN19",
  "DN20",
  "DN21",
  "DN22",
  "DN31",
  "DN32",
  "DN33",
  "DN34",
  "DN35",
  "DN36",
  "DN37",
  "DN38",
  "DN39",
  "DN40",
  "DN41",
  "LE1",
  "LE2",
  "LE3",
  "LE4",
  "LE5",
  "LE6",
  "LE7",
  "LE8",
  "LE9",
  "LE10",
  "LE11",
  "LE12",
  "LE13",
  "LE14",
  "LE15",
  "LE16",
  "LE17",
  "LE18",
  "LE19",
  "LE65",
  "LE67",
  "LN1",
  "LN2",
  "LN3",
  "LN4",
  "LN5",
  "LN6",
  "LN7",
  "LN8",
  "LN9",
  "LN10",
  "LN11",
  "LN12",
  "LN13",
  "NG1",
  "NG2",
  "NG3",
  "NG4",
  "NG5",
  "NG6",
  "NG7",
  "NG8",
  "NG9",
  "NG10",
  "NG11",
  "NG12",
  "NG13",
  "NG14",
  "NG15",
  "NG16",
  "NG17",
  "NG18",
  "NG19",
  "NG20",
  "NG21",
  "NG22",
  "NG23",
  "NG24",
  "NG25",
  "NG31",
  "NG32",
  "NG33",
  "NG34",
  "S1",
  "S2",
  "S3",
  "S4",
  "S5",
  "S6",
  "S7",
  "S8",
  "S9",
  "S10",
  "S11",
  "S12",
  "S13",
  "S14",
  "S17",
  "S18",
  "S20",
  "S21",
  "S25",
  "S26",
  "S32",
  "S33",
  "S35",
  "S36",
  "S40",
  "S41",
  "S42",
  "S43",
  "S44",
  "S45",
  "S60",
  "S61",
  "S62",
  "S63",
  "S64",
  "S65",
  "S66",
  "S70",
  "S71",
  "S72",
  "S73",
  "S74",
  "S75",
  "S80",
  "S81",
  "AL1",
  "AL2",
  "AL3",
  "AL4",
  "AL5",
  "AL6",
  "AL7",
  "AL8",
  "AL9",
  "AL10",
  "CB1",
  "CB2",
  "CB3",
  "CB4",
  "CB5",
  "CB6",
  "CB7",
  "CB8",
  "CB9",
  "CB10",
  "CB11",
  "CB21",
  "CB22",
  "CB23",
  "CB24",
  "CB25",
  "CM0",
  "CM1",
  "CM2",
  "CM3",
  "CM4",
  "CM5",
  "CM6",
  "CM7",
  "CM8",
  "CM9",
  "CM11",
  "CM12",
  "CM13",
  "CM14",
  "CM15",
  "CM16",
  "CM17",
  "CM18",
  "CM19",
  "CM20",
  "CM21",
  "CM22",
  "CM23",
  "CM24",
  "CM77",
  "CO1",
  "CO2",
  "CO3",
  "CO4",
  "CO5",
  "CO6",
  "CO7",
  "CO8",
  "CO9",
  "CO10",
  "CO11",
  "CO12",
  "CO13",
  "CO14",
  "CO15",
  "CO16",
  "HP1",
  "HP2",
  "HP3",
  "HP4",
  "HP5",
  "HP6",
  "HP7",
  "HP8",
  "HP9",
  "HP10",
  "HP11",
  "HP12",
  "HP13",
  "HP14",
  "HP15",
  "HP16",
  "HP17",
  "HP18",
  "HP19",
  "HP20",
  "HP21",
  "HP22",
  "HP23",
  "HP27",
  "IP1",
  "IP2",
  "IP3",
  "IP4",
  "IP5",
  "IP6",
  "IP7",
  "IP8",
  "IP9",
  "IP10",
  "IP11",
  "IP12",
  "IP13",
  "IP14",
  "IP15",
  "IP16",
  "IP17",
  "IP18",
  "IP19",
  "IP20",
  "IP21",
  "IP22",
  "IP23",
  "IP24",
  "IP25",
  "IP26",
  "IP27",
  "IP28",
  "IP29",
  "IP30",
  "IP31",
  "IP32",
  "IP33",
  "LU1",
  "LU2",
  "LU3",
  "LU4",
  "LU5",
  "LU6",
  "LU7",
  "NR1",
  "NR2",
  "NR3",
  "NR4",
  "NR5",
  "NR6",
  "NR7",
  "NR8",
  "NR9",
  "NR10",
  "NR11",
  "NR12",
  "NR13",
  "NR14",
  "NR15",
  "NR16",
  "NR17",
  "NR18",
  "NR19",
  "NR20",
  "NR21",
  "NR23",
  "NR24",
  "NR25",
  "NR26",
  "NR27",
  "NR28",
  "NR29",
  "NR30",
  "NR31",
  "NR32",
  "NR33",
  "NR34",
  "NR35",
  "PE1",
  "PE2",
  "PE3",
  "PE4",
  "PE6",
  "PE7",
  "PE8",
  "PE9",
  "PE10",
  "PE11",
  "PE12",
  "PE13",
  "PE14",
  "PE15",
  "PE16",
  "PE19",
  "PE20",
  "PE21",
  "PE22",
  "PE23",
  "PE24",
  "PE25",
  "PE26",
  "PE27",
  "PE28",
  "PE29",
  "PE30",
  "PE31",
  "PE32",
  "PE33",
  "PE34",
  "PE36",
  "PE37",
  "PE38",
  "SG1",
  "SG2",
  "SG3",
  "SG4",
  "SG5",
  "SG6",
  "SG7",
  "SG8",
  "SG9",
  "SG10",
  "SG11",
  "SG12",
  "SG13",
  "SG14",
  "SG15",
  "SG16",
  "SG17",
  "SG18",
  "SG19",
  "SS0",
  "SS1",
  "SS2",
  "SS3",
  "SS4",
  "SS5",
  "SS6",
  "SS7",
  "SS8",
  "SS9",
  "SS11",
  "SS12",
  "SS13",
  "SS14",
  "SS15",
  "SS16",
  "SS17",
  "BR1",
  "BR2",
  "BR3",
  "BR4",
  "BR5",
  "BR6",
  "BR7",
  "BR8",
  "CR0",
  "CR2",
  "CR3",
  "CR4",
  "CR5",
  "CR6",
  "CR7",
  "CR8",
  "DA1",
  "DA2",
  "DA3",
  "DA4",
  "DA5",
  "DA6",
  "DA7",
  "DA8",
  "DA9",
  "DA10",
  "DA11",
  "DA12",
  "DA13",
  "DA14",
  "DA15",
  "DA16",
  "DA17",
  "E1",
  "E2",
  "E3",
  "E4",
  "E5",
  "E6",
  "E7",
  "E8",
  "E9",
  "E10",
  "E11",
  "E12",
  "E13",
  "E14",
  "E15",
  "E16",
  "E17",
  "E18",
  "EC1",
  "EC2",
  "EC3",
  "EC4",
  "EN1",
  "EN2",
  "EN3",
  "EN4",
  "EN5",
  "EN6",
  "EN7",
  "EN8",
  "EN9",
  "EN10",
  "EN11",
  "HA0",
  "HA1",
  "HA2",
  "HA3",
  "HA4",
  "HA5",
  "HA6",
  "HA7",
  "HA8",
  "HA9",
  "IG1",
  "IG2",
  "IG3",
  "IG4",
  "IG5",
  "IG6",
  "IG7",
  "IG8",
  "IG9",
  "IG10",
  "IG11",
  "KT1",
  "KT2",
  "KT3",
  "KT4",
  "KT5",
  "KT6",
  "KT7",
  "KT8",
  "KT9",
  "KT10",
  "KT11",
  "KT12",
  "KT13",
  "KT14",
  "KT15",
  "KT16",
  "KT17",
  "KT18",
  "KT19",
  "KT20",
  "KT21",
  "KT22",
  "KT23",
  "KT24",
  "N1",
  "N2",
  "N3",
  "N4",
  "N5",
  "N6",
  "N7",
  "N8",
  "N9",
  "N10",
  "N11",
  "N12",
  "N13",
  "N14",
  "N15",
  "N16",
  "N17",
  "N18",
  "N19",
  "N20",
  "N21",
  "N22",
  "NW1",
  "NW2",
  "NW3",
  "NW4",
  "NW5",
  "NW6",
  "NW7",
  "NW8",
  "NW9",
  "NW10",
  "NW11",
  "RM1",
  "RM2",
  "RM3",
  "RM4",
  "RM5",
  "RM6",
  "RM7",
  "RM8",
  "RM9",
  "RM10",
  "RM11",
  "RM12",
  "RM13",
  "RM14",
  "RM15",
  "RM16",
  "RM17",
  "RM18",
  "RM19",
  "RM20",
  "SE1",
  "SE2",
  "SE3",
  "SE4",
  "SE5",
  "SE6",
  "SE7",
  "SE8",
  "SE9",
  "SE10",
  "SE11",
  "SE12",
  "SE13",
  "SE14",
  "SE15",
  "SE16",
  "SE17",
  "SE18",
  "SE19",
  "SE20",
  "SE21",
  "SE22",
  "SE23",
  "SE24",
  "SE25",
  "SE26",
  "SE27",
  "SE28",
  "SM1",
  "SM2",
  "SM3",
  "SM4",
  "SM5",
  "SM6",
  "SM7",
  "SW1",
  "SW2",
  "SW3",
  "SW4",
  "SW5",
  "SW6",
  "SW7",
  "SW8",
  "SW9",
  "SW10",
  "SW11",
  "SW12",
  "SW13",
  "SW14",
  "SW15",
  "SW16",
  "SW17",
  "SW18",
  "SW19",
  "SW20",
  "TW1",
  "TW2",
  "TW3",
  "TW4",
  "TW5",
  "TW7",
  "TW8",
  "TW9",
  "TW10",
  "TW11",
  "TW12",
  "TW13",
  "TW14",
  "TW15",
  "TW16",
  "TW17",
  "TW18",
  "TW19",
  "TW20",
  "UB1",
  "UB2",
  "UB3",
  "UB4",
  "UB5",
  "UB6",
  "UB7",
  "UB8",
  "UB9",
  "UB10",
  "W1",
  "W2",
  "W3",
  "W4",
  "W5",
  "W6",
  "W7",
  "W8",
  "W9",
  "W10",
  "W11",
  "W12",
  "W13",
  "W14",
  "WC1",
  "WC2",
  "WD3",
  "WD4",
  "WD5",
  "WD6",
  "WD7",
  "WD17",
  "WD18",
  "WD19",
  "WD23",
  "WD24",
  "WD25",
  "DH1",
  "DH2",
  "DH3",
  "DH4",
  "DH5",
  "DH6",
  "DH7",
  "DH8",
  "DH9",
  "DL1",
  "DL2",
  "DL3",
  "DL4",
  "DL5",
  "DL6",
  "DL7",
  "DL8",
  "DL9",
  "DL10",
  "DL11",
  "DL12",
  "DL13",
  "DL14",
  "DL15",
  "DL16",
  "DL17",
  "HG1",
  "HG2",
  "HG3",
  "HG4",
  "HG5",
  "HU1",
  "HU2",
  "HU3",
  "HU4",
  "HU5",
  "HU6",
  "HU7",
  "HU8",
  "HU9",
  "HU10",
  "HU11",
  "HU12",
  "HU13",
  "HU14",
  "HU15",
  "HU16",
  "HU17",
  "HU18",
  "HU19",
  "LS1",
  "LS2",
  "LS3",
  "LS4",
  "LS5",
  "LS6",
  "LS7",
  "LS8",
  "LS9",
  "LS10",
  "LS11",
  "LS12",
  "LS13",
  "LS14",
  "LS15",
  "LS16",
  "LS17",
  "LS18",
  "LS19",
  "LS20",
  "LS21",
  "LS22",
  "LS23",
  "LS24",
  "LS25",
  "LS26",
  "LS27",
  "LS28",
  "LS29",
  "NE1",
  "NE2",
  "NE3",
  "NE4",
  "NE5",
  "NE6",
  "NE7",
  "NE8",
  "NE9",
  "NE10",
  "NE11",
  "NE12",
  "NE13",
  "NE15",
  "NE16",
  "NE17",
  "NE19",
  "NE20",
  "NE21",
  "NE22",
  "NE23",
  "NE24",
  "NE25",
  "NE26",
  "NE27",
  "NE28",
  "NE29",
  "NE30",
  "NE31",
  "NE32",
  "NE33",
  "NE34",
  "NE35",
  "NE36",
  "NE37",
  "NE38",
  "NE39",
  "NE40",
  "NE41",
  "NE42",
  "NE43",
  "NE44",
  "NE45",
  "NE46",
  "NE47",
  "NE48",
  "NE49",
  "NE61",
  "NE62",
  "NE63",
  "NE64",
  "NE65",
  "NE66",
  "NE67",
  "NE68",
  "NE70",
  "NE71",
  "SR1",
  "SR2",
  "SR3",
  "SR4",
  "SR5",
  "SR6",
  "SR7",
  "SR8",
  "TS1",
  "TS3",
  "TS4",
  "TS5",
  "TS6",
  "TS7",
  "TS8",
  "TS9",
  "TS10",
  "TS11",
  "TS12",
  "TS13",
  "TS14",
  "TS15",
  "TS16",
  "TS17",
  "TS18",
  "TS19",
  "TS20",
  "TS21",
  "TS22",
  "TS23",
  "TS24",
  "TS25",
  "TS26",
  "TS27",
  "TS28",
  "TS29",
  "WF1",
  "WF2",
  "WF3",
  "WF4",
  "WF5",
  "WF6",
  "WF7",
  "WF8",
  "WF9",
  "WF10",
  "WF11",
  "WF12",
  "WF13",
  "WF14",
  "WF15",
  "WF16",
  "WF17",
  "YO1",
  "YO7",
  "YO8",
  "YO10",
  "YO11",
  "YO12",
  "YO13",
  "YO14",
  "YO15",
  "YO16",
  "YO17",
  "YO18",
  "YO19",
  "YO21",
  "YO22",
  "YO23",
  "YO24",
  "YO25",
  "YO26",
  "YO30",
  "YO31",
  "YO32",
  "YO41",
  "YO42",
  "YO43",
  "YO51",
  "YO60",
  "YO61",
  "YO62",
  "BB1",
  "BB2",
  "BB3",
  "BB4",
  "BB5",
  "BB6",
  "BB7",
  "BB8",
  "BB9",
  "BB10",
  "BB11",
  "BB12",
  "BB18",
  "BD1",
  "BD2",
  "BD3",
  "BD4",
  "BD5",
  "BD6",
  "BD7",
  "BD8",
  "BD9",
  "BD10",
  "BD11",
  "BD12",
  "BD13",
  "BD14",
  "BD15",
  "BD16",
  "BD17",
  "BD18",
  "BD19",
  "BD20",
  "BD21",
  "BD22",
  "BD23",
  "BD24",
  "BL0",
  "BL1",
  "BL2",
  "BL3",
  "BL4",
  "BL5",
  "BL6",
  "BL7",
  "BL8",
  "BL9",
  "CA1",
  "CA2",
  "CA3",
  "CA4",
  "CA5",
  "CA6",
  "CA7",
  "CA8",
  "CA9",
  "CA10",
  "CA11",
  "CA12",
  "CA13",
  "CA14",
  "CA15",
  "CA16",
  "CA17",
  "CA20",
  "CA22",
  "CA23",
  "CA25",
  "CA26",
  "CA27",
  "CA28",
  "CH1",
  "CH2",
  "CH3",
  "CH4",
  "CH5",
  "CH6",
  "CH7",
  "CH8",
  "CH41",
  "CH42",
  "CH43",
  "CH44",
  "CH45",
  "CH46",
  "CH47",
  "CH48",
  "CH49",
  "CH60",
  "CH61",
  "CH62",
  "CH63",
  "CH64",
  "CH65",
  "CH66",
  "CW1",
  "CW2",
  "CW3",
  "CW4",
  "CW5",
  "CW6",
  "CW7",
  "CW8",
  "CW9",
  "CW10",
  "CW11",
  "CW12",
  "FY1",
  "FY2",
  "FY3",
  "FY4",
  "FY5",
  "FY6",
  "FY7",
  "FY8",
  "HD1",
  "HD2",
  "HD3",
  "HD4",
  "HD5",
  "HD6",
  "HD7",
  "HD8",
  "HD9",
  "HX1",
  "HX2",
  "HX3",
  "HX4",
  "HX5",
  "HX6",
  "HX7",
  "L1",
  "L2",
  "L3",
  "L4",
  "L5",
  "L6",
  "L7",
  "L8",
  "L9",
  "L10",
  "L11",
  "L12",
  "L13",
  "L14",
  "L15",
  "L16",
  "L17",
  "L18",
  "L19",
  "L20",
  "L21",
  "L22",
  "L23",
  "L24",
  "L25",
  "L26",
  "L27",
  "L28",
  "L30",
  "L31",
  "L32",
  "L33",
  "L34",
  "L35",
  "L36",
  "L37",
  "L38",
  "L39",
  "L40",
  "LA1",
  "LA2",
  "LA3",
  "LA4",
  "LA5",
  "LA6",
  "LA7",
  "LA8",
  "LA9",
  "LA10",
  "LA11",
  "LA12",
  "LA13",
  "LA14",
  "LA15",
  "LA16",
  "LA17",
  "LA18",
  "LA20",
  "LA22",
  "LA23",
  "M1",
  "M2",
  "M3",
  "M4",
  "M5",
  "M6",
  "M7",
  "M8",
  "M9",
  "M11",
  "M12",
  "M13",
  "M14",
  "M15",
  "M16",
  "M18",
  "M19",
  "M20",
  "M21",
  "M22",
  "M23",
  "M24",
  "M25",
  "M26",
  "M27",
  "M28",
  "M29",
  "M30",
  "M31",
  "M32",
  "M33",
  "M34",
  "M35",
  "M38",
  "M40",
  "M41",
  "M43",
  "M44",
  "M45",
  "M46",
  "M50",
  "OL1",
  "OL2",
  "OL3",
  "OL4",
  "OL5",
  "OL6",
  "OL7",
  "OL8",
  "OL9",
  "OL10",
  "OL11",
  "OL12",
  "OL13",
  "OL14",
  "OL15",
  "OL16",
  "PR1",
  "PR2",
  "PR3",
  "PR4",
  "PR5",
  "PR6",
  "PR7",
  "PR8",
  "PR9",
  "PR25",
  "PR26",
  "SK1",
  "SK2",
  "SK3",
  "SK4",
  "SK5",
  "SK6",
  "SK7",
  "SK8",
  "SK9",
  "SK10",
  "SK11",
  "SK12",
  "SK13",
  "SK14",
  "SK15",
  "SK16",
  "SK17",
  "SK22",
  "SK23",
  "WA1",
  "WA2",
  "WA3",
  "WA4",
  "WA5",
  "WA6",
  "WA7",
  "WA8",
  "WA9",
  "WA10",
  "WA11",
  "WA12",
  "WA13",
  "WA14",
  "WA15",
  "WA16",
  "WN1",
  "WN2",
  "WN3",
  "WN4",
  "WN5",
  "WN6",
  "WN7",
  "WN8",
  "BN1",
  "BN2",
  "BN3",
  "BN5",
  "BN6",
  "BN7",
  "BN8",
  "BN9",
  "BN10",
  "BN11",
  "BN12",
  "BN13",
  "BN14",
  "BN15",
  "BN16",
  "BN17",
  "BN18",
  "BN20",
  "BN21",
  "BN22",
  "BN23",
  "BN24",
  "BN25",
  "BN26",
  "BN27",
  "BN41",
  "BN42",
  "BN43",
  "BN44",
  "CT1",
  "CT2",
  "CT3",
  "CT4",
  "CT5",
  "CT6",
  "CT7",
  "CT8",
  "CT9",
  "CT10",
  "CT11",
  "CT12",
  "CT13",
  "CT14",
  "CT15",
  "CT16",
  "CT17",
  "CT18",
  "CT19",
  "CT20",
  "CT21",
  "GU1",
  "GU2",
  "GU3",
  "GU4",
  "GU5",
  "GU6",
  "GU7",
  "GU8",
  "GU9",
  "GU10",
  "GU11",
  "GU12",
  "GU14",
  "GU15",
  "GU16",
  "GU17",
  "GU18",
  "GU19",
  "GU20",
  "GU21",
  "GU22",
  "GU23",
  "GU24",
  "GU25",
  "GU26",
  "GU27",
  "GU28",
  "GU29",
  "GU30",
  "GU31",
  "GU32",
  "GU33",
  "GU34",
  "GU35",
  "GU46",
  "GU47",
  "GU51",
  "GU52",
  "ME1",
  "ME2",
  "ME3",
  "ME4",
  "ME5",
  "ME6",
  "ME7",
  "ME8",
  "ME9",
  "ME10",
  "ME11",
  "ME12",
  "ME13",
  "ME14",
  "ME15",
  "ME16",
  "ME17",
  "ME18",
  "ME19",
  "ME20",
  "MK2",
  "MK3",
  "MK4",
  "MK5",
  "MK6",
  "MK7",
  "MK8",
  "MK9",
  "MK10",
  "MK11",
  "MK12",
  "MK13",
  "MK14",
  "MK15",
  "MK16",
  "MK17",
  "MK18",
  "MK19",
  "MK40",
  "MK41",
  "MK42",
  "MK43",
  "MK44",
  "MK45",
  "MK46",
  "OX1",
  "OX2",
  "OX3",
  "OX4",
  "OX5",
  "OX7",
  "OX9",
  "OX10",
  "OX11",
  "OX12",
  "OX13",
  "OX14",
  "OX15",
  "OX16",
  "OX17",
  "OX18",
  "OX20",
  "OX25",
  "OX26",
  "OX27",
  "OX28",
  "OX29",
  "OX33",
  "OX39",
  "OX44",
  "OX49",
  "PO1",
  "PO2",
  "PO3",
  "PO4",
  "PO5",
  "PO6",
  "PO7",
  "PO8",
  "PO9",
  "PO10",
  "PO11",
  "PO12",
  "PO13",
  "PO14",
  "PO15",
  "PO16",
  "PO17",
  "PO18",
  "PO19",
  "PO20",
  "PO21",
  "PO22",
  "PO30",
  "PO31",
  "PO32",
  "PO33",
  "PO34",
  "PO35",
  "PO36",
  "PO37",
  "PO38",
  "PO39",
  "PO40",
  "PO41",
  "RG1",
  "RG2",
  "RG4",
  "RG5",
  "RG6",
  "RG7",
  "RG8",
  "RG9",
  "RG10",
  "RG12",
  "RG14",
  "RG17",
  "RG18",
  "RG19",
  "RG20",
  "RG21",
  "RG22",
  "RG23",
  "RG24",
  "RG25",
  "RG26",
  "RG27",
  "RG28",
  "RG29",
  "RG30",
  "RG31",
  "RG40",
  "RG41",
  "RG42",
  "RG45",
  "RH1",
  "RH2",
  "RH3",
  "RH4",
  "RH5",
  "RH6",
  "RH7",
  "RH8",
  "RH9",
  "RH10",
  "RH11",
  "RH12",
  "RH13",
  "RH14",
  "RH15",
  "RH16",
  "RH17",
  "RH18",
  "RH19",
  "RH20",
  "SL0",
  "SL1",
  "SL2",
  "SL3",
  "SL4",
  "SL5",
  "SL6",
  "SL7",
  "SL8",
  "SL9",
  "SO14",
  "SO15",
  "SO16",
  "SO17",
  "SO18",
  "SO19",
  "SO20",
  "SO21",
  "SO22",
  "SO23",
  "SO24",
  "SO30",
  "SO31",
  "SO32",
  "SO40",
  "SO41",
  "SO42",
  "SO43",
  "SO45",
  "SO50",
  "SO51",
  "SO52",
  "SO53",
  "TN1",
  "TN2",
  "TN3",
  "TN4",
  "TN5",
  "TN6",
  "TN7",
  "TN8",
  "TN9",
  "TN10",
  "TN11",
  "TN12",
  "TN13",
  "TN14",
  "TN15",
  "TN16",
  "TN17",
  "TN18",
  "TN19",
  "TN20",
  "TN21",
  "TN22",
  "TN23",
  "TN24",
  "TN25",
  "TN26",
  "TN27",
  "TN28",
  "TN29",
  "TN30",
  "TN31",
  "TN32",
  "TN33",
  "TN34",
  "TN35",
  "TN36",
  "TN37",
  "TN38",
  "TN39",
  "TN40",
  "BA1",
  "BA2",
  "BA3",
  "BA4",
  "BA5",
  "BA6",
  "BA7",
  "BA8",
  "BA9",
  "BA10",
  "BA11",
  "BA12",
  "BA13",
  "BA14",
  "BA15",
  "BA16",
  "BA20",
  "BA21",
  "BA22",
  "BH1",
  "BH2",
  "BH3",
  "BH4",
  "BH5",
  "BH6",
  "BH7",
  "BH8",
  "BH9",
  "BH10",
  "BH11",
  "BH12",
  "BH13",
  "BH14",
  "BH15",
  "BH16",
  "BH17",
  "BH18",
  "BH19",
  "BH20",
  "BH21",
  "BH22",
  "BH23",
  "BH24",
  "BH25",
  "BH31",
  "BS1",
  "BS2",
  "BS3",
  "BS4",
  "BS5",
  "BS6",
  "BS7",
  "BS8",
  "BS9",
  "BS10",
  "BS11",
  "BS13",
  "BS14",
  "BS15",
  "BS16",
  "BS20",
  "BS21",
  "BS22",
  "BS23",
  "BS24",
  "BS25",
  "BS26",
  "BS27",
  "BS28",
  "BS29",
  "BS30",
  "BS31",
  "BS32",
  "BS34",
  "BS35",
  "BS36",
  "BS37",
  "BS39",
  "BS40",
  "BS41",
  "BS48",
  "BS49",
  "DT1",
  "DT2",
  "DT3",
  "DT4",
  "DT5",
  "DT6",
  "DT7",
  "DT8",
  "DT9",
  "DT10",
  "DT11",
  "EX1",
  "EX2",
  "EX3",
  "EX4",
  "EX5",
  "EX6",
  "EX7",
  "EX8",
  "EX9",
  "EX10",
  "EX11",
  "EX12",
  "EX13",
  "EX14",
  "EX15",
  "EX16",
  "EX17",
  "EX18",
  "EX19",
  "EX20",
  "EX21",
  "EX22",
  "EX23",
  "EX24",
  "EX31",
  "EX32",
  "EX33",
  "EX34",
  "EX35",
  "EX36",
  "EX37",
  "EX38",
  "EX39",
  "GL1",
  "GL2",
  "GL3",
  "GL4",
  "GL5",
  "GL6",
  "GL7",
  "GL8",
  "GL10",
  "GL11",
  "GL12",
  "GL13",
  "GL14",
  "GL15",
  "GL16",
  "GL17",
  "GL18",
  "GL19",
  "GL20",
  "GL50",
  "GL51",
  "GL52",
  "GL53",
  "GL54",
  "GL55",
  "GL56",
  "PL1",
  "PL2",
  "PL3",
  "PL4",
  "PL5",
  "PL6",
  "PL7",
  "PL8",
  "PL9",
  "PL10",
  "PL11",
  "PL12",
  "PL13",
  "PL14",
  "PL15",
  "PL16",
  "PL17",
  "PL18",
  "PL19",
  "PL20",
  "PL21",
  "PL22",
  "PL23",
  "PL24",
  "PL25",
  "PL26",
  "PL27",
  "PL28",
  "PL29",
  "PL30",
  "PL31",
  "PL32",
  "PL33",
  "PL34",
  "PL35",
  "SN1",
  "SN2",
  "SN3",
  "SN4",
  "SN5",
  "SN6",
  "SN7",
  "SN8",
  "SN9",
  "SN10",
  "SN11",
  "SN12",
  "SN13",
  "SN14",
  "SN15",
  "SN16",
  "SN25",
  "SN26",
  "SP1",
  "SP2",
  "SP3",
  "SP4",
  "SP5",
  "SP6",
  "SP7",
  "SP8",
  "SP9",
  "SP10",
  "SP11",
  "TA1",
  "TA2",
  "TA3",
  "TA4",
  "TA5",
  "TA6",
  "TA7",
  "TA8",
  "TA9",
  "TA10",
  "TA11",
  "TA12",
  "TA13",
  "TA14",
  "TA16",
  "TA18",
  "TA19",
  "TA20",
  "TA21",
  "TA22",
  "TA23",
  "TA24",
  "TQ1",
  "TQ2",
  "TQ3",
  "TQ4",
  "TQ5",
  "TQ6",
  "TQ7",
  "TQ8",
  "TQ9",
  "TQ10",
  "TQ11",
  "TQ12",
  "TQ13",
  "TQ14",
  "TR1",
  "TR2",
  "TR3",
  "TR4",
  "TR5",
  "TR6",
  "TR7",
  "TR8",
  "TR9",
  "TR10",
  "TR11",
  "TR12",
  "TR13",
  "TR14",
  "TR15",
  "TR16",
  "TR17",
  "TR18",
  "TR19",
  "TR20",
  "TR26",
  "TR27",
  "CF3",
  "CF5",
  "CF10",
  "CF11",
  "CF14",
  "CF15",
  "CF23",
  "CF24",
  "CF31",
  "CF32",
  "CF33",
  "CF34",
  "CF35",
  "CF36",
  "CF37",
  "CF38",
  "CF39",
  "CF40",
  "CF41",
  "CF42",
  "CF43",
  "CF44",
  "CF45",
  "CF46",
  "CF47",
  "CF48",
  "CF61",
  "CF62",
  "CF63",
  "CF64",
  "CF71",
  "CF72",
  "CF81",
  "CF82",
  "CF83",
  "LD1",
  "LD2",
  "LD3",
  "LD4",
  "LD5",
  "LD6",
  "LD7",
  "LD8",
  "LL11",
  "LL12",
  "LL13",
  "LL14",
  "LL15",
  "LL16",
  "LL17",
  "LL18",
  "LL19",
  "LL20",
  "LL21",
  "LL22",
  "LL23",
  "LL24",
  "LL26",
  "LL28",
  "LL29",
  "LL30",
  "LL31",
  "LL32",
  "LL33",
  "LL34",
  "LL35",
  "LL36",
  "LL40",
  "LL41",
  "LL42",
  "LL44",
  "LL46",
  "LL48",
  "LL49",
  "LL52",
  "LL53",
  "LL54",
  "LL55",
  "LL56",
  "LL57",
  "LL58",
  "LL59",
  "LL60",
  "LL61",
  "LL65",
  "LL67",
  "LL68",
  "LL74",
  "LL75",
  "LL77",
  "NP4",
  "NP7",
  "NP8",
  "NP10",
  "NP11",
  "NP12",
  "NP13",
  "NP15",
  "NP16",
  "NP18",
  "NP19",
  "NP20",
  "NP22",
  "NP23",
  "NP24",
  "NP25",
  "NP26",
  "NP44",
  "SA1",
  "SA2",
  "SA3",
  "SA4",
  "SA5",
  "SA6",
  "SA7",
  "SA8",
  "SA9",
  "SA10",
  "SA11",
  "SA12",
  "SA13",
  "SA14",
  "SA15",
  "SA16",
  "SA17",
  "SA18",
  "SA19",
  "SA20",
  "SA31",
  "SA32",
  "SA33",
  "SA34",
  "SA37",
  "SA38",
  "SA39",
  "SA40",
  "SA41",
  "SA42",
  "SA43",
  "SA44",
  "SA45",
  "SA46",
  "SA47",
  "SA48",
  "SA61",
  "SA62",
  "SA64",
  "SA65",
  "SA66",
  "SA67",
  "SA68",
  "SA69",
  "SA70",
  "SA71",
  "SA72",
  "SA73",
  "SY1",
  "SY2",
  "SY3",
  "SY4",
  "SY5",
  "SY6",
  "SY7",
  "SY8",
  "SY10",
  "SY11",
  "SY12",
  "SY13",
  "SY14",
  "SY15",
  "SY16",
  "SY17",
  "SY18",
  "SY20",
  "SY21",
  "SY22",
  "SY23",
  "SY24",
  "SY25",
  "B1",
  "B2",
  "B3",
  "B4",
  "B5",
  "B6",
  "B8",
  "B9",
  "B10",
  "B11",
  "B12",
  "B13",
  "B14",
  "B15",
  "B16",
  "B17",
  "B18",
  "B19",
  "B20",
  "B21",
  "B23",
  "B24",
  "B25",
  "B26",
  "B27",
  "B28",
  "B29",
  "B30",
  "B31",
  "B32",
  "B33",
  "B34",
  "B35",
  "B36",
  "B37",
  "B38",
  "B42",
  "B43",
  "B44",
  "B45",
  "B46",
  "B47",
  "B48",
  "B49",
  "B50",
  "B60",
  "B61",
  "B62",
  "B63",
  "B64",
  "B65",
  "B66",
  "B67",
  "B68",
  "B69",
  "B70",
  "B71",
  "B72",
  "B73",
  "B74",
  "B75",
  "B76",
  "B77",
  "B78",
  "B79",
  "B80",
  "B90",
  "B91",
  "B92",
  "B93",
  "B94",
  "B95",
  "B96",
  "B97",
  "B98",
  "CV1",
  "CV2",
  "CV3",
  "CV4",
  "CV5",
  "CV6",
  "CV7",
  "CV8",
  "CV9",
  "CV10",
  "CV11",
  "CV12",
  "CV13",
  "CV21",
  "CV22",
  "CV23",
  "CV31",
  "CV32",
  "CV33",
  "CV34",
  "CV35",
  "CV36",
  "CV37",
  "CV47",
  "DY1",
  "DY2",
  "DY3",
  "DY4",
  "DY5",
  "DY6",
  "DY7",
  "DY8",
  "DY9",
  "DY10",
  "DY11",
  "DY12",
  "DY13",
  "DY14",
  "HR1",
  "HR2",
  "HR3",
  "HR4",
  "HR5",
  "HR6",
  "HR7",
  "HR8",
  "HR9",
  "NN1",
  "NN2",
  "NN3",
  "NN4",
  "NN5",
  "NN6",
  "NN7",
  "NN8",
  "NN9",
  "NN10",
  "NN11",
  "NN12",
  "NN13",
  "NN14",
  "NN15",
  "NN16",
  "NN17",
  "NN18",
  "NN29",
  "ST1",
  "ST2",
  "ST3",
  "ST4",
  "ST5",
  "ST6",
  "ST7",
  "ST8",
  "ST9",
  "ST10",
  "ST11",
  "ST12",
  "ST13",
  "ST14",
  "ST15",
  "ST16",
  "ST17",
  "ST18",
  "ST19",
  "ST20",
  "ST21",
  "TF1",
  "TF2",
  "TF3",
  "TF4",
  "TF5",
  "TF6",
  "TF7",
  "TF8",
  "TF9",
  "TF10",
  "TF11",
  "TF12",
  "TF13",
  "WR1",
  "WR2",
  "WR3",
  "WR4",
  "WR5",
  "WR6",
  "WR7",
  "WR8",
  "WR9",
  "WR10",
  "WR11",
  "WR12",
  "WR13",
  "WR14",
  "WR15",
  "WS1",
  "WS2",
  "WS3",
  "WS4",
  "WS5",
  "WS6",
  "WS7",
  "WS8",
  "WS9",
  "WS10",
  "WS11",
  "WS12",
  "WS13",
  "WS14",
  "WS15",
  "WV1",
  "WV2",
  "WV3",
  "WV4",
  "WV5",
  "WV6",
  "WV7",
  "WV8",
  "WV9",
  "WV10",
  "WV11",
  "WV12",
  "WV13",
  "WV14",
  "WV15",
  "WV16",
];
